import React from "react"
import { Link } from "gatsby"
import { kebabCase } from "lodash"
import parse from "html-react-parser"
import CopyLinkButton from "./copy-link-button"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const PageByNumbers = ({ props, annualReport }) => {
  const { backgroundColor } = props
  const posts = props?.pbnNumbers
  if (!posts?.length) {
    return <div></div>
  }

  return (
    <section
      key={props.heading || props.includeInStickyMenu?.menuTitle}
      className={`section relative print:bg-transparent ${annualReport === "2024" ? "m-section" : annualReport === "2023" ? "bg-green-blue-waves bg-cover p-section bg-fixed" : annualReport === "2022" ? "bg-gray-200 p-section" :
        backgroundColor && backgroundColor !== "transparent"
          ? "bg-gradient-to-b pt-section mb-section print:from-transparent " +
          (backgroundColor === "blue-100"
            ? "from-blue-300 "
            : backgroundColor === "green-100"
              ? "from-green-300"
              : "")
          : "bg-transparent m-section"
        }`}
    >
      <div className={`relative ${annualReport === "2023" ? "sm:container" : "container"}`}>
        <div className={`${annualReport === "2024" ? "text-center text-blue-800 " : annualReport === '2022' ? `border-l-6 pl-4 relative border-l-green` : annualReport === "2023" ? "px-8 sm:px-0" : ""}`}>
          <div className="group-copy-link group grid grid-cols-1 justify-start">
            {props.heading ? (
              <>
                <h2
                  id={kebabCase(props.heading).replace(/[0-9]/g, "")}
                  className="anchor-heading mb-6"
                >
                  {parse(props.heading)}
                </h2>
                <CopyLinkButton heading={props.heading} />
              </>
            ) : props.includeInStickyMenu?.menuTitle ? (
              <div id={kebabCase(props.includeInStickyMenu.menuTitle) || ""}>
                <CopyLinkButton heading={props.includeInStickyMenu.menuTitle} />
              </div>
            ) : null}
          </div>
          {props.leadContent ? (
            <div
              className={` max-w-4xl ${annualReport === "2024" ? "mx-auto h3" : "parsed-content lead-content"}`}
            >
              {parse(props.leadContent)}
            </div>
          ) : null}
        </div>
        <ol
          className={`mt-12 mx-auto grid ${annualReport === "2024" ? `sm:grid-cols-2 md:grid-cols-3 ${posts.length === 6 ? "xl:grid-cols-6" : "lg:grid-cols-4 xl:grid-cols-5"} gap-x-4 gap-y-5` : annualReport === "2023" ? "md:block gap-4 md:gap-0 md:masonry md:masonry-cols-2 xl:masonry-cols-3 md:space-y-6" : `gap-10 sm:grid-cols-2 ${posts?.length === 4
            ? `md:grid-cols-2 xl:grid-cols-4`
            : `md:grid-cols-3 2xl:grid-cols-5`}`
            }`}
        >
          {posts &&
            posts?.map((post, index) => {
              const link = post.pageByNumbersCustomListing?.link?.url || ""
              const target = post.pageByNumbersCustomListing?.link?.target || "_self"
              const value = post.pageByNumbersCustomListing
              return (
                <>{(
                  value?.numberPrepend ||
                  value?.number ||
                  value?.numberAppend ||
                  value?.numberDescription ||
                  value?.numberContent
                ) ? <li key={link + index}>
                  <article
                    className={`break-inside-avoid flex flex-col ${annualReport === "2024" ? "bg-ar24-blue-100 rounded-lg h-full" : annualReport === "2023" ? " shadow-md bg-white/40" : "rounded-lg shadow bg-white"} transform  print:shadow-none print:border print:border-gray-300 print:mb-4 transition 
                      ${annualReport === "2022" ? `border-l-6 border-b-6 border-green` : ""}
                      ${link
                        ? `hover:shadow-lg  hover:scale-105 ${annualReport === "2022" ? ` hover:border-green-700` : ""}`
                        : ""
                      }`}
                    itemScope
                    itemType="http://schema.org/Article"
                  >
                    <div className="flex-1">
                      {link ? (
                        <Link
                          to={link}
                          className="block px-6 py-5 link-plain"
                          itemProp="url"
                          target={target}
                        >
                          <PageByNumbersValue annualReport={annualReport} value={value} />
                        </Link>
                      ) : (
                        <div className="block px-6 py-5">
                          <PageByNumbersValue annualReport={annualReport} value={value} />
                        </div>
                      )}
                    </div>
                  </article>
                </li> : null}</>
              )
            })}
        </ol>
      </div>
    </section >
  )
}

export default PageByNumbers

const PageByNumbersValue = ({ value, annualReport }) => {
  const icon = {
    src: value.icon?.localFile
      ? getImage(value.icon?.localFile)
      : null,
    extension: value.icon?.localFile?.extension,
    alt: value.icon?.altText || ``,
    publicURL: value.icon?.localFile?.publicURL,
  }
  return (
    <>
      <header className="text-base">
        <h3 className={`${annualReport === "2024" ? "" : "text-semibold text-lg"} ${annualReport === "2023" ? "text-right" : ""}`}>
          {value.icon ? (
            <div className="w-20 h-20 relative flex items-center justify-center mb-2">
              {icon?.extension !== "svg" ? (
                <GatsbyImage
                  image={icon.src}
                  className="w-full h-auto"
                  alt={icon.alt}
                  objectFit="contain" />

              ) : icon?.publicURL ? (
                <img
                  src={icon.publicURL}
                  className={`object-contain w-full h-auto`}
                  alt={icon.alt} />
              ) : null}
            </div>
          ) : null
          }

          <span className={annualReport === "2024" ? "h4" : annualReport === "2023" ? "inline-block float-left mb-5" : ""}>
            {value.numberPrepend ? <span>{value.numberPrepend}</span> : null}
            {value.number ? <span
              itemProp="headline"
              className={`text-3xl md:text-4xl inline-block ${annualReport === "2024" ? "xl:text-4xl 2xl:text-5xl font-black text-ar24-blue-100 text-stroke-blue-700" : annualReport === "2023" ? "2xl:text-5xl" : "xl:text-5xl"}`}

            >
              {value.number}
            </span> : null}
            {value.numberAppend ? <span>{value.numberAppend}</span> : null}
          </span>

          {value.numberDescription ? <span itemProp="description" className={` ${annualReport === "2024" ? "font-normal block leading-snug text-base" : annualReport === "2023" ? "font-medium text-right ml-auto pl-2" : "xl:text-lg block leading-tight "}`}>
            {value.numberDescription}
          </span> : null}
        </h3>
        {value.numberContent ? (
          <div itemProp="content" className={`parsed-content leading-snug ${annualReport === "2024" ? "font-light text-gray-800" : annualReport === "2023" ? "inline-block align-bottom" : "mt-3"}`}>
            {parse(value.numberContent)}
          </div>
        ) : null}
      </header>
    </>
  )
}
